export { getParameterFromURL } from './getParameterFromUrl';
export { getOnboardingAnswersFromURL, getOnboardingTypeByConfig } from './onboardingAnswers';
export { getFirstScreenFromURL } from './firstScreen';
export { createLocaleTextGetter } from './getLocaleText';
